import React from "react"
import parse from 'html-react-parser'
import katex from "katex"
import "./App/katex.min.css"

const SimpleMath = (props) => {
    const math = katex.renderToString(props.mathString, {displayMode:props.display, trust: true, output:"html"});
    return (
        <span id={props.size} style={props.display ? {display:'block'} : {display: "inline-block"}}>
            { parse(math) }
        </span>
)}

export default SimpleMath;
